import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseInput from '../../../components/inputs/BaseInput'
import parseNumericInput from '../utils/parseNumericInput'

interface PriceInputProps {
	title: string
	value: string | undefined
	unit: string
	onValueChange: (value: string) => void
}

/**
 * PriceInput component renders a numeric input field with a title.
 *
 * @param {PriceInputProps} props - The properties for the PriceInput component
 * @returns {JSX.Element} The rendered PriceInput component
 */
const PriceInput: React.FC<PriceInputProps> = ({ title, value, unit, onValueChange }) => {
	const { t } = useTranslation('modals_contractOptions')

	return (
		<div className='input-container'>
			<BaseInput
				type='text'
				value={value?.toString() ?? ''}
				label={t(title as any)}
				onChange={inputValue => {
					if (inputValue === '') {
						onValueChange('')
						return
					}
					const parsedValue = parseNumericInput((inputValue ?? '').toString())
					onValueChange(typeof parsedValue === 'number' ? String(parsedValue) : parsedValue)
				}}
				onBlur={value => {
					if (value === '') {
						onValueChange('0')
					}
				}}
				endAdornment={unit}
			/>
		</div>
	)
}

export default PriceInput
